import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const useModuleStore = defineStore("module", {
    state: () => {
        return {
            moduleCategories: [],
            moduleClicks: [],
            moduleCost: [],
            moduleImpressions: [],
        };
    },
    actions: {
        async fetchModuleCategories({ shopId, data }) {
            return axiosInstance
                .get(`/v1/analytics/module-categories/${shopId}`, { params: data })
                .then((response) => (this.moduleCategories = response.data));
        },
        async fetchModuleClicks({ shopId, data }) {
            return axiosInstance
                .get(`/v1/analytics/module-clicks/${shopId}`, { params: data })
                .then((response) => (this.moduleClicks = response.data));
        },
        async fetchModuleCost({ shopId, data }) {
            return axiosInstance
                .get(`/v1/analytics/module-cost/${shopId}`, { params: data })
                .then((response) => (this.moduleCost = response.data));
        },
        async fetchModuleImpressions({ shopId, data }) {
            return axiosInstance
                .get(`/v1/analytics/module-impressions/${shopId}`, { params: data })
                .then((response) => (this.moduleImpressions = response.data));
        },
        async fetchGraphData(graphData) {
            await Promise.all([
                this.fetchModuleClicks(graphData),
                this.fetchModuleCost(graphData),
                this.fetchModuleImpressions(graphData),
            ]);
        },
    },
});
